// // src/Components/Admin.jsx
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { collection, addDoc, serverTimestamp } from "firebase/firestore";
// import { db } from "./firebase";


// //for email 
// import {
//   getDocs,
//   deleteDoc,
//   doc,
// } from "firebase/firestore";


// // Cloudinary config from .env
// const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
// const IMAGE_PRESET = process.env.REACT_APP_CLOUDINARY_IMAGE_PRESET; // e.g. navveer_unsigned_preset
// // PDF_PRESET no longer needed because we don't upload PDF to Cloudinary

// export default function Admin() {
//   // Tab selection: "book" | "blog" | "foundation"
//   const [activeTab, setActiveTab] = useState("book");


//   //add for emial
//   // 🔐 Premium Email Management
// const [premiumEmail, setPremiumEmail] = useState("");
// const [premiumEmails, setPremiumEmails] = useState([]);

// //Add for username
// const [premiumUsername, setPremiumUsername] = useState("");


// // Load premium emails
// const loadPremiumEmails = async () => {
//   const snap = await getDocs(collection(db, "premiumEmails"));
//   setPremiumEmails(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
// };
// // Add premium email
// const addPremiumEmail = async () => {
//   if (!premiumEmail.trim() || !premiumUsername.trim()) {
//     alert("Please enter both email and username");
//     return;
//   }

//   await addDoc(collection(db, "premiumEmails"), {
//     email: premiumEmail.trim().toLowerCase(),
//     username: premiumUsername.trim(),
//     createdAt: serverTimestamp(),
//   });

//   setPremiumEmail("");
//   setPremiumUsername("");
//   loadPremiumEmails();
// };

// // Remove premium email
// const removePremiumEmail = async (id) => {
//   if (!window.confirm("Remove premium access?")) return;
//   await deleteDoc(doc(db, "premiumEmails", id));
//   loadPremiumEmails();
// };





//   // Shared Book / Foundation form state
//   const [bookTitle, setBookTitle] = useState("");
//   const [bookAuthor, setBookAuthor] = useState("");
//   const [coverFile, setCoverFile] = useState(null);
//   const [coverPreview, setCoverPreview] = useState(null);
//   const [bookPdfLink, setBookPdfLink] = useState(""); // 🔗 Drive / URL for PDF
//   const [uploading, setUploading] = useState(false);

//   // Blog form state
//   const [blogTitle, setBlogTitle] = useState("");
//   const [blogExcerpt, setBlogExcerpt] = useState("");
//   const [blogContent, setBlogContent] = useState("");
//   const [blogCategory, setBlogCategory] = useState("Announcements");
//   const [blogAuthor, setBlogAuthor] = useState("");
//   const [blogDate, setBlogDate] = useState("");
//   const [blogImageFile, setBlogImageFile] = useState(null);
//   const [blogImagePreview, setBlogImagePreview] = useState(null);

//   const navigate = useNavigate();

//   const handleCoverChange = (e) => {
//     const f = e.target.files?.[0] ?? null;
//     setCoverFile(f);
//     if (f) {
//       setCoverPreview(URL.createObjectURL(f));
//     } else {
//       setCoverPreview(null);
//     }
//   };

//   const handleBlogImageChange = (e) => {
//     const f = e.target.files?.[0] ?? null;
//     setBlogImageFile(f);
//     if (f) {
//       setBlogImagePreview(URL.createObjectURL(f));
//     } else {
//       setBlogImagePreview(null);
//     }
//   };

//   // ✅ Admin logout
//   const handleLogout = () => {
//     localStorage.removeItem("navveer_admin_auth");
//     navigate("/admin-login");
//   };

//   // Generic Cloudinary upload helper
//   async function uploadToCloudinary(file, { resourceType, preset, folder }) {
//     if (!CLOUD_NAME || !preset) {
//       throw new Error("Cloudinary env vars missing. Check your .env file.");
//     }

//     const url = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/${resourceType}/upload`;
//     const fd = new FormData();
//     fd.append("file", file);
//     fd.append("upload_preset", preset);
//     if (folder) fd.append("folder", folder);

//     const res = await fetch(url, { method: "POST", body: fd });
//     if (!res.ok) {
//       const text = await res.text();
//       throw new Error(`Cloudinary upload failed: ${res.status} ${text}`);
//     }

//     return res.json(); // { secure_url, public_id, ... }
//   }

//   const handleUploadBook = async (e) => {
//     e.preventDefault();

//     const isFoundationTab = activeTab === "foundation";
//     const collectionName = isFoundationTab ? "foundationBooks" : "books";

//     if (!bookTitle.trim() || !bookAuthor.trim()) {
//       alert("Please enter book title and author.");
//       return;
//     }
//     if (!coverFile) {
//       alert("Please select a cover image.");
//       return;
//     }
//     if (!bookPdfLink.trim()) {
//       alert("Please paste the PDF link (Google Drive / any URL).");
//       return;
//     }

//     try {
//       setUploading(true);

//       // 1) Upload cover image to Cloudinary (image resource)
//       const coverResp = await uploadToCloudinary(coverFile, {
//         resourceType: "image",
//         preset: IMAGE_PRESET,
//         folder: isFoundationTab ? "NavveerFoundationBooks" : "E-Books",
//       });
//       const coverUrl = coverResp.secure_url || coverResp.url;

//       // 2) Use the provided Drive/URL link for PDF (NO upload)
//       const pdfUrl = bookPdfLink.trim();

//       // 3) Save metadata in Firestore to correct collection
//       const docRef = await addDoc(collection(db, collectionName), {
//         title: bookTitle.trim(),
//         author: bookAuthor.trim(),
//         coverUrl,
//         pdfUrl, // just the link you entered
//         createdAt: serverTimestamp(),
//       });

//       // Optional: let Books page update instantly (separate events)
//       if (isFoundationTab) {
//         window.dispatchEvent(
//           new CustomEvent("foundationBookUploaded", {
//             detail: {
//               id: docRef.id,
//               title: bookTitle.trim(),
//               author: bookAuthor.trim(),
//               coverUrl,
//               pdfUrl,
//             },
//           })
//         );
//       } else {
//         window.dispatchEvent(
//           new CustomEvent("bookUploaded", {
//             detail: {
//               id: docRef.id,
//               title: bookTitle.trim(),
//               author: bookAuthor.trim(),
//               coverUrl,
//               pdfUrl,
//             },
//           })
//         );
//       }

//       alert(
//         isFoundationTab
//           ? "Navveer Foundation book details saved successfully!"
//           : "Book details saved successfully!"
//       );

//       // Reset shared book form
//       setBookTitle("");
//       setBookAuthor("");
//       setCoverFile(null);
//       setCoverPreview(null);
//       setBookPdfLink("");
//       setUploading(false);

//       // You can change this if Foundation should have different page
//       navigate("/admin");
//     } catch (err) {
//       console.error("Book upload error:", err);
//       alert("Failed to save book: " + (err.message || err));
//       setUploading(false);
//     }
//   };

//   const handleCreateBlog = async (e) => {
//     e.preventDefault();
//     if (!blogTitle || !blogExcerpt || !blogContent || !blogAuthor || !blogDate) {
//       alert("Please fill in all blog fields.");
//       return;
//     }

//     // Basic check to prevent HTML tags in content
//     const htmlTagRegex = /<[^>]+>/;
//     if (htmlTagRegex.test(blogContent)) {
//       alert("Please do not insert HTML tags in the content. Use plain text only.");
//       return;
//     }

//     try {
//       let blogImageUrl = null;

//       // If a blog image is selected, upload to Cloudinary
//       if (blogImageFile) {
//         const imgResp = await uploadToCloudinary(blogImageFile, {
//           resourceType: "image",
//           preset: IMAGE_PRESET,
//           folder: "BlogImages",
//         });
//         blogImageUrl = imgResp.secure_url || imgResp.url;
//       }

//       const added = await addDoc(collection(db, "blogs"), {
//         title: blogTitle,
//         excerpt: blogExcerpt,
//         content: blogContent,
//         category: blogCategory,
//         author: blogAuthor,
//         date: blogDate,
//         imageUrl: blogImageUrl,
//         createdAt: serverTimestamp(),
//       });

//       window.dispatchEvent(
//         new CustomEvent("blogCreated", {
//           detail: {
//             id: added.id,
//             title: blogTitle,
//             excerpt: blogExcerpt,
//             category: blogCategory,
//             author: blogAuthor,
//             date: blogDate,
//             imageUrl: blogImageUrl,
//           },
//         })
//       );

//       alert("Blog post created!");

//       // Reset blog form
//       setBlogTitle("");
//       setBlogExcerpt("");
//       setBlogContent("");
//       setBlogCategory("Announcements");
//       setBlogAuthor("");
//       setBlogDate("");
//       setBlogImageFile(null);
//       setBlogImagePreview(null);
//     } catch (err) {
//       console.error("Blog create error:", err);
//       alert("Failed to create blog: " + (err.message || err));
//     }
//   };

//   const isFoundationTab = activeTab === "foundation";

//   return (
//     <div style={{ padding: 16, maxWidth: 900, margin: "0 auto" }}>
//       {/* Header + Logout */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           gap: 8,
//           marginBottom: 8,
//         }}
//       >
//         <h2 style={{ margin: 0 }}>Admin Panel — Uploads (Cloudinary + Drive Link)</h2>

//         <button
//           onClick={handleLogout}
//           style={{
//             padding: "6px 12px",
//             borderRadius: 6,
//             border: "1px solid #ccc",
//             backgroundColor: "#f44336",
//             color: "#fff",
//             cursor: "pointer",
//             fontSize: 14,
//             fontWeight: 600,
//           }}
//         >
//           Logout
//         </button>
//       </div>

//       {/* TAB BUTTONS */}
//       <div
//         style={{
//           marginTop: 16,
//           marginBottom: 16,
//           display: "flex",
//           gap: 8,
//           flexWrap: "wrap",
//         }}
//       >
//         <button
//           type="button"
//           onClick={() => setActiveTab("book")}
//           style={{
//             padding: "8px 16px",
//             borderRadius: 6,
//             border: "1px solid #ccc",
//             cursor: "pointer",
//             backgroundColor: activeTab === "book" ? "#007bff" : "#f5f5f5",
//             color: activeTab === "book" ? "#fff" : "#000",
//             fontWeight: activeTab === "book" ? "600" : "400",
//           }}
//         >
//           📚 Book Upload
//         </button>

//         <button
//           type="button"
//           onClick={() => setActiveTab("blog")}
//           style={{
//             padding: "8px 16px",
//             borderRadius: 6,
//             border: "1px solid #ccc",
//             cursor: "pointer",
//             backgroundColor: activeTab === "blog" ? "#007bff" : "#f5f5f5",
//             color: activeTab === "blog" ? "#fff" : "#000",
//             fontWeight: activeTab === "blog" ? "600" : "400",
//           }}
//         >
//           📝 Blog Upload
//         </button>

//         <button
//           type="button"
//           onClick={() => setActiveTab("foundation")}
//           style={{
//             padding: "8px 16px",
//             borderRadius: 6,
//             border: "1px solid #ccc",
//             cursor: "pointer",
//             backgroundColor: activeTab === "foundation" ? "#007bff" : "#f5f5f5",
//             color: activeTab === "foundation" ? "#fff" : "#000",
//             fontWeight: activeTab === "foundation" ? "600" : "400",
//           }}
//         >
//           📘 NavveerFoundation
//         </button>
//       </div>


// {/* // email management UI can be added here later */}
// <button
//   type="button"
//   onClick={() => {
//     setActiveTab("premium");
//     loadPremiumEmails();
//   }}
// >
//   🔐 Premium Access
// </button>







// {activeTab === "premium" && (
//   <section style={{ border: "1px solid #ddd", padding: 16 }}>
//     <h3>🔐 Premium Email Access</h3>

//     <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
//       <input
//         type="email"
//         placeholder="user@email.com"
//         value={premiumEmail}
//         onChange={(e) => setPremiumEmail(e.target.value)}
//       />

//       <input
//         type="text"
//         placeholder="Username (display name)"
//         value={premiumUsername}
//         onChange={(e) => setPremiumUsername(e.target.value)}
//       />

//       <button onClick={addPremiumEmail}>Add</button>
//     </div>

//     {premiumEmails.length === 0 ? (
//       <p>No premium users added.</p>
//     ) : (
//       <ul>
//         {premiumEmails.map((e) => (
//           <li key={e.id}>
//             <strong>{e.username}</strong> — {e.email}
//             <button
//               onClick={() => removePremiumEmail(e.id)}
//               style={{ marginLeft: 10, color: "red" }}
//             >
//               Remove
//             </button>
//           </li>
//         ))}
//       </ul>
//     )}
//   </section>
// )}






//       {/* BOOK / FOUNDATION UPLOAD (shared UI) */}
//       {(activeTab === "book" || activeTab === "foundation") && (
//         <section
//           style={{
//             marginTop: 8,
//             border: "1px solid #ddd",
//             padding: 16,
//             borderRadius: 8,
//           }}
//         >
//           <h3>
//             {isFoundationTab
//               ? "📘 Navveer Foundation Book Upload"
//               : "📚 Upload Book (Cover to Cloudinary, PDF via Link)"}
//           </h3>
//           <form onSubmit={handleUploadBook}>
//             <div style={{ display: "grid", gap: 8 }}>
//               <input
//                 type="text"
//                 placeholder="Book Title"
//                 value={bookTitle}
//                 onChange={(e) => setBookTitle(e.target.value)}
//               />
//               <input
//                 type="text"
//                 placeholder="Author Name"
//                 value={bookAuthor}
//                 onChange={(e) => setBookAuthor(e.target.value)}
//               />

//               <label>
//                 Cover Image (jpg/png)
//                 <input type="file" accept="image/*" onChange={handleCoverChange} />
//               </label>

//               {coverPreview && (
//                 <div style={{ width: 140, height: 200 }}>
//                   <img
//                     src={coverPreview}
//                     alt="Cover preview"
//                     style={{
//                       width: "100%",
//                       height: "100%",
//                       objectFit: "cover",
//                       borderRadius: 4,
//                     }}
//                   />
//                 </div>
//               )}

//               {/* PDF LINK INSTEAD OF FILE UPLOAD */}
//               <label>
//                 Book PDF Link (Google Drive / any URL)
//                 <input
//                   type="url"
//                   placeholder="https://drive.google.com/..."
//                   value={bookPdfLink}
//                   onChange={(e) => setBookPdfLink(e.target.value)}
//                   style={{ width: "100%" }}
//                 />
//               </label>

//               <div>
//                 <button type="submit" disabled={uploading}>
//                   {uploading
//                     ? isFoundationTab
//                       ? "Saving Navveer Foundation Book..."
//                       : "Saving..."
//                     : isFoundationTab
//                     ? "Save Navveer Foundation Book"
//                     : "Save Book"}
//                 </button>
//               </div>
//             </div>
//           </form>
//         </section>
//       )}

//       {/* BLOG CREATE */}
//       {activeTab === "blog" && (
//         <section
//           style={{
//             marginTop: 8,
//             border: "1px solid #ddd",
//             padding: 16,
//             borderRadius: 8,
//           }}
//         >
//           <h3>📝 Create Blog Post</h3>
//           <form onSubmit={handleCreateBlog}>
//             <div style={{ display: "grid", gap: 8 }}>
//               <input
//                 type="text"
//                 placeholder="Blog Title"
//                 value={blogTitle}
//                 onChange={(e) => setBlogTitle(e.target.value)}
//               />
//               <input
//                 type="text"
//                 placeholder="Excerpt (short summary)"
//                 value={blogExcerpt}
//                 onChange={(e) => setBlogExcerpt(e.target.value)}
//               />
//               <textarea
//                 placeholder="Content (plain text only, no HTML tags)"
//                 value={blogContent}
//                 onChange={(e) => setBlogContent(e.target.value)}
//                 rows={6}
//               />
//               <input
//                 type="text"
//                 placeholder="Author name"
//                 value={blogAuthor}
//                 onChange={(e) => setBlogAuthor(e.target.value)}
//               />
//               <input
//                 type="date"
//                 value={blogDate}
//                 onChange={(e) => setBlogDate(e.target.value)}
//               />
//               <select
//                 value={blogCategory}
//                 onChange={(e) => setBlogCategory(e.target.value)}
//               >
//                 <option>Announcements</option>
//                 <option>Education</option>
//                 <option>Healthcare</option>
//                 <option>Empowerment</option>
//               </select>

//               {/* BLOG IMAGE UPLOAD */}
//               <label>
//                 Blog Image (optional)
//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={handleBlogImageChange}
//                 />
//               </label>

//               {blogImagePreview && (
//                 <div style={{ width: 200, height: 120 }}>
//                   <img
//                     src={blogImagePreview}
//                     alt="Blog preview"
//                     style={{
//                       width: "100%",
//                       height: "100%",
//                       objectFit: "cover",
//                       borderRadius: 4,
//                     }}
//                   />
//                 </div>
//               )}

//               <div>
//                 <button type="submit">Create Blog Post</button>
//               </div>
//             </div>
//           </form>
//         </section>
//                   )}
      
//     </div>
//   );
// }

//The updated code for the mail access 

// src/Components/Admin.jsx
//import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
//import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import React, { useState, useEffect } from "react";

import {
  collection,
  addDoc,
  serverTimestamp,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
//for email 
// import {
//   getDocs,
//   deleteDoc,
//   doc,
// } from "firebase/firestore";


// Cloudinary config from .env
const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const IMAGE_PRESET = process.env.REACT_APP_CLOUDINARY_IMAGE_PRESET; // e.g. navveer_unsigned_preset
// PDF_PRESET no longer needed because we don't upload PDF to Cloudinary

export default function Admin() {
  // Tab selection: "book" | "blog" | "foundation"
  const [activeTab, setActiveTab] = useState("book");


  //add for emial
  // 🔐 Premium Email Management
/* ================= PREMIUM ACCESS ================= */
const [premiumEmail, setPremiumEmail] = useState("");
const [premiumUsername, setPremiumUsername] = useState("");
const [premiumEmails, setPremiumEmails] = useState([]);

const [books, setBooks] = useState([]);
const [selectedBookIds, setSelectedBookIds] = useState([]);







// Load premium emails
const loadPremiumEmails = async () => {
  const snap = await getDocs(collection(db, "premiumEmails"));
  setPremiumEmails(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
};



const loadBooks = async () => {
  const snap = await getDocs(collection(db, "books"));
  setBooks(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
};

useEffect(() => {
  if (activeTab === "premium") {
    loadPremiumEmails();
    loadBooks();
  }
}, [activeTab]);

const toggleBook = (id) => {
  setSelectedBookIds((prev) =>
    prev.includes(id) ? prev.filter((b) => b !== id) : [...prev, id]
  );
};

// Add premium email
const addPremiumEmail = async () => {
  if (!premiumEmail.trim() || !premiumUsername.trim()) {
    alert("Please enter email and username");
    return;
  }

  await addDoc(collection(db, "premiumEmails"), {
    email: premiumEmail.trim().toLowerCase(),
    username: premiumUsername.trim(),
    allowedBookIds: selectedBookIds,
    createdAt: serverTimestamp(),
  });

  setPremiumEmail("");
  setPremiumUsername("");
  setSelectedBookIds([]);
  loadPremiumEmails();
};

// Remove premium email
const updateAccess = async (id) => {
  await updateDoc(doc(db, "premiumEmails", id), {
    allowedBookIds: selectedBookIds,
  });
  alert("Book access updated");
  setSelectedBookIds([]);
  loadPremiumEmails();
};

const removePremiumEmail = async (id) => {
  if (!window.confirm("Remove premium access?")) return;
  await deleteDoc(doc(db, "premiumEmails", id));
  loadPremiumEmails();
};






  // Shared Book / Foundation form state
  const [bookTitle, setBookTitle] = useState("");
  const [bookAuthor, setBookAuthor] = useState("");
  const [coverFile, setCoverFile] = useState(null);
  const [coverPreview, setCoverPreview] = useState(null);
  const [bookPdfLink, setBookPdfLink] = useState(""); // 🔗 Drive / URL for PDF
  const [uploading, setUploading] = useState(false);

  // Blog form state
  const [blogTitle, setBlogTitle] = useState("");
  const [blogExcerpt, setBlogExcerpt] = useState("");
  const [blogContent, setBlogContent] = useState("");
  const [blogCategory, setBlogCategory] = useState("Announcements");
  const [blogAuthor, setBlogAuthor] = useState("");
  const [blogDate, setBlogDate] = useState("");
  const [blogImageFile, setBlogImageFile] = useState(null);
  const [blogImagePreview, setBlogImagePreview] = useState(null);

  const navigate = useNavigate();

  const handleCoverChange = (e) => {
    const f = e.target.files?.[0] ?? null;
    setCoverFile(f);
    if (f) {
      setCoverPreview(URL.createObjectURL(f));
    } else {
      setCoverPreview(null);
    }
  };

  const handleBlogImageChange = (e) => {
    const f = e.target.files?.[0] ?? null;
    setBlogImageFile(f);
    if (f) {
      setBlogImagePreview(URL.createObjectURL(f));
    } else {
      setBlogImagePreview(null);
    }
  };

  // ✅ Admin logout
  const handleLogout = () => {
    localStorage.removeItem("navveer_admin_auth");
    navigate("/admin-login");
  };

  // Generic Cloudinary upload helper
  async function uploadToCloudinary(file, { resourceType, preset, folder }) {
    if (!CLOUD_NAME || !preset) {
      throw new Error("Cloudinary env vars missing. Check your .env file.");
    }

    const url = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/${resourceType}/upload`;
    const fd = new FormData();
    fd.append("file", file);
    fd.append("upload_preset", preset);
    if (folder) fd.append("folder", folder);

    const res = await fetch(url, { method: "POST", body: fd });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Cloudinary upload failed: ${res.status} ${text}`);
    }

    return res.json(); // { secure_url, public_id, ... }
  }

  const handleUploadBook = async (e) => {
    e.preventDefault();

    const isFoundationTab = activeTab === "foundation";
    const collectionName = isFoundationTab ? "foundationBooks" : "books";

    if (!bookTitle.trim() || !bookAuthor.trim()) {
      alert("Please enter book title and author.");
      return;
    }
    if (!coverFile) {
      alert("Please select a cover image.");
      return;
    }
    if (!bookPdfLink.trim()) {
      alert("Please paste the PDF link (Google Drive / any URL).");
      return;
    }

    try {
      setUploading(true);

      // 1) Upload cover image to Cloudinary (image resource)
      const coverResp = await uploadToCloudinary(coverFile, {
        resourceType: "image",
        preset: IMAGE_PRESET,
        folder: isFoundationTab ? "NavveerFoundationBooks" : "E-Books",
      });
      const coverUrl = coverResp.secure_url || coverResp.url;

      // 2) Use the provided Drive/URL link for PDF (NO upload)
      const pdfUrl = bookPdfLink.trim();

      // 3) Save metadata in Firestore to correct collection
      const docRef = await addDoc(collection(db, collectionName), {
        title: bookTitle.trim(),
        author: bookAuthor.trim(),
        coverUrl,
        pdfUrl, // just the link you entered
        createdAt: serverTimestamp(),
      });

      // Optional: let Books page update instantly (separate events)
      if (isFoundationTab) {
        window.dispatchEvent(
          new CustomEvent("foundationBookUploaded", {
            detail: {
              id: docRef.id,
              title: bookTitle.trim(),
              author: bookAuthor.trim(),
              coverUrl,
              pdfUrl,
            },
          })
        );
      } else {
        window.dispatchEvent(
          new CustomEvent("bookUploaded", {
            detail: {
              id: docRef.id,
              title: bookTitle.trim(),
              author: bookAuthor.trim(),
              coverUrl,
              pdfUrl,
            },
          })
        );
      }

      alert(
        isFoundationTab
          ? "Navveer Foundation book details saved successfully!"
          : "Book details saved successfully!"
      );

      // Reset shared book form
      setBookTitle("");
      setBookAuthor("");
      setCoverFile(null);
      setCoverPreview(null);
      setBookPdfLink("");
      setUploading(false);

      // You can change this if Foundation should have different page
      navigate("/admin");
    } catch (err) {
      console.error("Book upload error:", err);
      alert("Failed to save book: " + (err.message || err));
      setUploading(false);
    }
  };

  const handleCreateBlog = async (e) => {
    e.preventDefault();
    if (!blogTitle || !blogExcerpt || !blogContent || !blogAuthor || !blogDate) {
      alert("Please fill in all blog fields.");
      return;
    }

    // Basic check to prevent HTML tags in content
    const htmlTagRegex = /<[^>]+>/;
    if (htmlTagRegex.test(blogContent)) {
      alert("Please do not insert HTML tags in the content. Use plain text only.");
      return;
    }

    try {
      let blogImageUrl = null;

      // If a blog image is selected, upload to Cloudinary
      if (blogImageFile) {
        const imgResp = await uploadToCloudinary(blogImageFile, {
          resourceType: "image",
          preset: IMAGE_PRESET,
          folder: "BlogImages",
        });
        blogImageUrl = imgResp.secure_url || imgResp.url;
      }

      const added = await addDoc(collection(db, "blogs"), {
        title: blogTitle,
        excerpt: blogExcerpt,
        content: blogContent,
        category: blogCategory,
        author: blogAuthor,
        date: blogDate,
        imageUrl: blogImageUrl,
        createdAt: serverTimestamp(),
      });

      window.dispatchEvent(
        new CustomEvent("blogCreated", {
          detail: {
            id: added.id,
            title: blogTitle,
            excerpt: blogExcerpt,
            category: blogCategory,
            author: blogAuthor,
            date: blogDate,
            imageUrl: blogImageUrl,
          },
        })
      );

      alert("Blog post created!");

      // Reset blog form
      setBlogTitle("");
      setBlogExcerpt("");
      setBlogContent("");
      setBlogCategory("Announcements");
      setBlogAuthor("");
      setBlogDate("");
      setBlogImageFile(null);
      setBlogImagePreview(null);
    } catch (err) {
      console.error("Blog create error:", err);
      alert("Failed to create blog: " + (err.message || err));
    }
  };

  const isFoundationTab = activeTab === "foundation";

  return (
    <div style={{ padding: 16, maxWidth: 900, margin: "0 auto" }}>
      {/* Header + Logout */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 8,
          marginBottom: 8,
        }}
      >
        <h2 style={{ margin: 0 }}>Admin Panel — Uploads (Cloudinary + Drive Link)</h2>

        <button
          onClick={handleLogout}
          style={{
            padding: "6px 12px",
            borderRadius: 6,
            border: "1px solid #ccc",
            backgroundColor: "#f44336",
            color: "#fff",
            cursor: "pointer",
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          Logout
        </button>
      </div>

      {/* TAB BUTTONS */}
      <div
        style={{
          marginTop: 16,
          marginBottom: 16,
          display: "flex",
          gap: 8,
          flexWrap: "wrap",
        }}
      >
        <button
          type="button"
          onClick={() => setActiveTab("book")}
          style={{
            padding: "8px 16px",
            borderRadius: 6,
            border: "1px solid #ccc",
            cursor: "pointer",
            backgroundColor: activeTab === "book" ? "#007bff" : "#f5f5f5",
            color: activeTab === "book" ? "#fff" : "#000",
            fontWeight: activeTab === "book" ? "600" : "400",
          }}
        >
          📚 Book Upload
        </button>

        <button
          type="button"
          onClick={() => setActiveTab("blog")}
          style={{
            padding: "8px 16px",
            borderRadius: 6,
            border: "1px solid #ccc",
            cursor: "pointer",
            backgroundColor: activeTab === "blog" ? "#007bff" : "#f5f5f5",
            color: activeTab === "blog" ? "#fff" : "#000",
            fontWeight: activeTab === "blog" ? "600" : "400",
          }}
        >
          📝 Blog Upload
        </button>

        <button
          type="button"
          onClick={() => setActiveTab("foundation")}
          style={{
            padding: "8px 16px",
            borderRadius: 6,
            border: "1px solid #ccc",
            cursor: "pointer",
            backgroundColor: activeTab === "foundation" ? "#007bff" : "#f5f5f5",
            color: activeTab === "foundation" ? "#fff" : "#000",
            fontWeight: activeTab === "foundation" ? "600" : "400",
          }}
        >
          📘 NavveerFoundation
        </button>
      </div>


{/* // email management UI can be added here later */}
<button
  type="button"
  onClick={() => {
    setActiveTab("premium");
    loadPremiumEmails();
  }}
>
  🔐 Premium Access
</button>







{/* PREMIUM ACCESS */}
{activeTab === "premium" && (
  <section>
    <h3>🔐 Premium Book Access</h3>

    <input
      placeholder="Email"
      value={premiumEmail}
      onChange={(e) => setPremiumEmail(e.target.value)}
    />

    <input
      placeholder="Username"
      value={premiumUsername}
      onChange={(e) => setPremiumUsername(e.target.value)}
    />

    <h4>Select Books</h4>
    {books.map((b) => (
      <label key={b.id} style={{ display: "block" }}>
        <input
          type="checkbox"
          checked={selectedBookIds.includes(b.id)}
          onChange={() => toggleBook(b.id)}
        />
        {b.title}
      </label>
    ))}

    <button onClick={addPremiumEmail}>Add Premium User</button>

    <ul>
      {premiumEmails.map((u) => (
        <li key={u.id}>
          {u.username} — {u.email}
          <button onClick={() => updateAccess(u.id)}>Update</button>
          <button onClick={() => removePremiumEmail(u.id)}>Remove</button>
        </li>
      ))}
    </ul>
  </section>
)}




      {/* BOOK / FOUNDATION UPLOAD (shared UI) */}
      {(activeTab === "book" || activeTab === "foundation") && (
        <section
          style={{
            marginTop: 8,
            border: "1px solid #ddd",
            padding: 16,
            borderRadius: 8,
          }}
        >
          <h3>
            {isFoundationTab
              ? "📘 Navveer Foundation Book Upload"
              : "📚 Upload Book (Cover to Cloudinary, PDF via Link)"}
          </h3>
          <form onSubmit={handleUploadBook}>
            <div style={{ display: "grid", gap: 8 }}>
              <input
                type="text"
                placeholder="Book Title"
                value={bookTitle}
                onChange={(e) => setBookTitle(e.target.value)}
              />
              <input
                type="text"
                placeholder="Author Name"
                value={bookAuthor}
                onChange={(e) => setBookAuthor(e.target.value)}
              />

              <label>
                Cover Image (jpg/png)
                <input type="file" accept="image/*" onChange={handleCoverChange} />
              </label>

              {coverPreview && (
                <div style={{ width: 140, height: 200 }}>
                  <img
                    src={coverPreview}
                    alt="Cover preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: 4,
                    }}
                  />
                </div>
              )}

              {/* PDF LINK INSTEAD OF FILE UPLOAD */}
              <label>
                Book PDF Link (Google Drive / any URL)
                <input
                  type="url"
                  placeholder="https://drive.google.com/..."
                  value={bookPdfLink}
                  onChange={(e) => setBookPdfLink(e.target.value)}
                  style={{ width: "100%" }}
                />
              </label>

              <div>
                <button type="submit" disabled={uploading}>
                  {uploading
                    ? isFoundationTab
                      ? "Saving Navveer Foundation Book..."
                      : "Saving..."
                    : isFoundationTab
                    ? "Save Navveer Foundation Book"
                    : "Save Book"}
                </button>
              </div>
            </div>
          </form>
        </section>
      )}

      {/* BLOG CREATE */}
      {activeTab === "blog" && (
        <section
          style={{
            marginTop: 8,
            border: "1px solid #ddd",
            padding: 16,
            borderRadius: 8,
          }}
        >
          <h3>📝 Create Blog Post</h3>
          <form onSubmit={handleCreateBlog}>
            <div style={{ display: "grid", gap: 8 }}>
              <input
                type="text"
                placeholder="Blog Title"
                value={blogTitle}
                onChange={(e) => setBlogTitle(e.target.value)}
              />
              <input
                type="text"
                placeholder="Excerpt (short summary)"
                value={blogExcerpt}
                onChange={(e) => setBlogExcerpt(e.target.value)}
              />
              <textarea
                placeholder="Content (plain text only, no HTML tags)"
                value={blogContent}
                onChange={(e) => setBlogContent(e.target.value)}
                rows={6}
              />
              <input
                type="text"
                placeholder="Author name"
                value={blogAuthor}
                onChange={(e) => setBlogAuthor(e.target.value)}
              />
              <input
                type="date"
                value={blogDate}
                onChange={(e) => setBlogDate(e.target.value)}
              />
              <select
                value={blogCategory}
                onChange={(e) => setBlogCategory(e.target.value)}
              >
                <option>Announcements</option>
                <option>Education</option>
                <option>Healthcare</option>
                <option>Empowerment</option>
              </select>

              {/* BLOG IMAGE UPLOAD */}
              <label>
                Blog Image (optional)
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleBlogImageChange}
                />
              </label>

              {blogImagePreview && (
                <div style={{ width: 200, height: 120 }}>
                  <img
                    src={blogImagePreview}
                    alt="Blog preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: 4,
                    }}
                  />
                </div>
              )}

              <div>
                <button type="submit">Create Blog Post</button>
              </div>
            </div>
          </form>
        </section>






                  )}
      
    </div>
  );
}



















